// Builds the source-question options for the open-end recode form.
// Open and open-multiple questions are selected by their own card token.
// For a closed question that has an "other, specify" option, the free text lives in a
// server-generated companion question whose card token is `<cardToken>_Other_`, NOT the
// closed question itself (whose answers are codes). The option must therefore point to
// that companion so the recode codifies the verbatims and not the closed answer codes.
export const computeOpenEndQuestionOptions = (cards, localizeText) => {
  const openMultiple = [];
  const open = [];
  const otherSpecify = [];

  (cards || []).forEach((c) => {
    const specs = c.specs || {};
    if (specs.is_pii) return;

    const title = localizeText(specs.localized_title || specs.question);
    if (c.type === "q_open_multiple") {
      openMultiple.push({ label: title ? `${c.name} - ${title}` : c.name || c.token, value: c.token });
    } else if (c.type === "q_open") {
      open.push({ label: title ? `${c.name} - ${title}` : c.name || c.token, value: c.token });
    } else if (specs.is_other && specs.answers?.some((a) => a.is_other)) {
      otherSpecify.push({
        label: title ? `${c.name} - ${title} (other)` : `${c.name || c.token} (other)`,
        value: `${c.token}_Other_`,
      });
    }
  });

  const options = [];
  if (openMultiple.length) {
    options.push({ label: "Open multiple", value: "__group_open_multiple__", disabled: true });
    options.push(...openMultiple);
  }
  if (open.length) {
    options.push({ label: "Open", value: "__group_open__", disabled: true });
    options.push(...open);
  }
  if (otherSpecify.length) {
    options.push({ label: "Other specify", value: "__group_other__", disabled: true });
    options.push(...otherSpecify);
  }
  return options;
};
